import { connect } from 'react-redux'
import requestApplyCardTemplate from '../../sagas/requestApplyCardTemplate'
import applyTemplateSelector from './applyTemplateSelector'
import ApplyTemplate from './ApplyTemplate'

export default connect(
  applyTemplateSelector,
  {
    requestApplyCardTemplate
  }
)(ApplyTemplate)
